export default __webpack_public_path__ + "static/media/table_cancer_En.f8070ee3.webp";